import { render } from "./SkinAnalysisLoading.vue?vue&type=template&id=cb633e6a"
import script from "./SkinAnalysisLoading.vue?vue&type=script&lang=js"
export * from "./SkinAnalysisLoading.vue?vue&type=script&lang=js"

import "./SkinAnalysisLoading.vue?vue&type=style&index=0&id=cb633e6a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__